import { Factory } from './Factory'
import Menu from '../EditorComponents/BlogPosts/Menu'

export class BlogPostsFactory extends Factory {
  constructor(qty = 1) {
    super()
    this.qty = qty
  }

  object() {
    return {
      id: this.id('blogposts'),
      slug: 'editor-blog-posts',
      assets: {
        phone: [],
        tablet: [],
        desktop: []
      },
      background: {
        phone: 'color',
        tablet: 'color',
        desktop: 'color'
      },
      customClasses: [],
      constantClasses: {
        phone: [
        ],
        tablet: [
        ],
        desktop: [
        ]
      },
      containerClasses: {
        phone: [],
        tablet: [],
        desktop: []
      },
      name: 'BlogPosts',
    }
  }

  gridItems() {
    return [
      {value: 1, text: '1 column'},
      {value: 2, text: '2 columns'},
      {value: 3, text: '3 columns'},
      {value: 4, text: '4 columns'},
      {value: 5, text: '5 columns'},
      {value: 6, text: '6 columns'},
    ]
  }

  properties() {
    return {
      content: [
        {key: 'blog-filter', component:'BlogPostsFilter'},
        {key: 'grid', component: 'ContentSelect', text: 'Grid', property: 'postsGrid', items: this.gridItems()},
        {key: 'image', component:'ContentToggle', text:'Image', property:'showImage'},
        {key: 'author', component:'ContentToggle', text:'Author', property:'showAuthor'},
        {key: 'title', component:'ContentToggle', text:'Title', property:'showTitle'},
        {key: 'read_more', component:'ContentToggle', text:'Read More', property:'showReadMore'},
        {key: 'read_more_text', component:'ContentText', text:'Read More', property:'readMoreText'},
        {key: 'description', component:'ContentToggle', text:'Description', property:'showDescription'},
        {key: 'published_date', component:'ContentToggle', text:'Published Date', property:'showPublishedDate'},
        {key: 'categories', component:'ContentToggle', text:'Categories', property:'showCategories'},
        {key: 'tags', component:'ContentToggle', text:'Tags', property:'showTags'},
      ],
      styles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color']},
        {key: 'rounded', component:'RoundedProperty'},
        {key: 'shadow', component:'ShadowProperty'},
        {key: 'border', component:'BorderProperty'},
        {key: 'padding', component:'PaddingProperty'},
        {key: 'margin', component:'MarginProperty'},
      ],
      contentStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'contentClasses', styles: 'contentStyles'},
        {key: 'padding', component:'PaddingProperty', class:'contentClasses'},
      ],
      authorStyles: [
        {key: 'color', component:'TextColorProperty', styles: 'authorStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'authorClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'authorClasses'},
        {key: 'margin', component:'MarginProperty', class:'authorClasses'},
      ],
      titleStyles: [
        {key: 'color', component:'TextColorProperty', styles: 'titleStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'titleClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'titleClasses'},
        {key: 'margin', component:'MarginProperty', class:'titleClasses'},
      ],
      descriptionStyles: [
        {key: 'color', component:'TextColorProperty', styles: 'descriptionStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'descriptionClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'descriptionClasses'},
        {key: 'margin', component:'MarginProperty', class:'descriptionClasses'},
      ],
      dateStyles: [
        {key: 'color', component:'TextColorProperty', styles: 'dateStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'dateClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'dateClasses'},
        {key: 'margin', component:'MarginProperty', class:'dateClasses'},
      ],
      tagsStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'tagsClasses', styles: 'tagsStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'tagsClasses'},
        {key: 'shadow', component:'ShadowProperty', class:'tagsClasses'},
        {key: 'color', component:'TextColorProperty', styles: 'tagsStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'tagsClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'tagsClasses'},
        {key: 'border', component:'BorderProperty', class:'tagsClasses', styles: 'tagsStyles'},
        {key: 'padding', component:'PaddingProperty', class:'tagsClasses'},
        {key: 'margin', component:'MarginProperty', class:'tagsClasses'},
      ],
      categoriesStyles: [
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'categoriesClasses', styles: 'categoriesStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'categoriesClasses'},
        {key: 'shadow', component:'ShadowProperty', class:'categoriesClasses'},
        {key: 'color', component:'TextColorProperty', styles: 'categoriesStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'categoriesClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'categoriesClasses'},
        {key: 'border', component:'BorderProperty', class:'categoriesClasses', styles: 'categoriesStyles'},
        {key: 'padding', component:'PaddingProperty', class:'categoriesClasses'},
        {key: 'margin', component:'MarginProperty', class:'categoriesClasses'},
      ],
      readMoreStyles: [
        {key: 'width', component:'WidthProperty', class:'readMoreClasses'},
        {key: 'text-alignment', component:'TextAlignmentProperty', class:'readMoreContainerClasses', except: ['JUSTIFY']},
        {key: 'background-color', component:'BackgroundProperty', only: ['color'], class:'readMoreClasses', styles: 'readMoreStyles'},
        {key: 'rounded', component:'RoundedProperty', class:'readMoreClasses'},
        {key: 'shadow', component:'ShadowProperty', class:'readMoreClasses'},
        {key: 'border', component:'BorderProperty', class:'readMoreClasses', styles: 'readMoreStyles'},
        {key: 'font-size', component: 'FontSizeProperty', class:'readMoreClasses'},
        {key: 'font-weight', component: 'FontWeightProperty', class:'readMoreClasses'},
        {key: 'color', component:'TextColorProperty', styles: 'readMoreStyles'},
        {key: 'padding', component:'PaddingProperty', class:'readMoreClasses'},
        {key: 'margin', component:'MarginProperty', class:'readMoreContainerClasses'},
      ],
      advanced: [
      ],
      menu: Menu
    }
  }
}